<template>
  <div
    :title="itemData.title"
    class="element_card flex h-full w-full cursor-pointer flex-row-reverse overflow-hidden rounded bg-white shadow-normal shadow-gray-400 hover:shadow-blue-400/50 tablet:flex-col"
    @click="handleClick"
  >
    <figure
      class="relative block overflow-hidden"
      :class="
        isMobile ? 'h-[140px] w-[120px] basis-[120px]' : 'aspect-video w-full'
      "
    >
      <img
        :src="itemData.imageUrl"
        :alt="itemData.title"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
    <div class="flex flex-1 p-3 tablet:flex-col tablet:p-4 desktop:p-5">
      <div class="tablet:flex-1">
        <h3
          class="mb-2 line-clamp-2 text-sm font-bold leading-6 tablet:text-base"
        >
          {{ itemData.title }}
        </h3>
        <p
          class="line-clamp-3 w-full text-sm text-gray-600 tablet:mb-2 tablet:line-clamp-4"
        >
          {{ itemData.description }}
        </p>
      </div>
      <div class="hidden tablet:flex tablet:justify-end">
        <TheNuxtLink
          :to="itemData.link"
          :title="itemData.title"
          class="element_arrow flex h-8 w-8 basis-8 items-center justify-center rounded text-blue-400"
        >
          <IconArrow class="h-5 w-5" direction="right" />
        </TheNuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface IResource {
    imageUrl: string;
    title: string;
    description: string;
    link: string;
  }

  interface IProps {
    itemData: IResource;
  }

  const props = withDefaults(defineProps<IProps>(), {
    itemData: () => ({
      imageUrl: '',
      title: '',
      description: '',
      link: '',
    }),
  });

  const router = useRouter();
  const { isMobile } = useScreen();

  const handleClick = (): void => {
    router.push(props.itemData.link);
  };

  export type { IResource };
</script>

<style lang="scss" scoped>
  .element_card:hover {
    .element_arrow {
      @apply bg-blue-400 text-white;
    }
  }
</style>
